export default __webpack_public_path__ + "static/media/beauty.95b186c9.png";